const Styles = {
  cardStyle: {
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 15,
    marginTop: 12,
    height: "calc(100% - 80px)",
    overflow: "auto",
    position: "relative",
  },
  filters: {
    position: "relative",
    marginBottom: "2rem",
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
  },
  search: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
  },
  searchInput: {
    width: "40%",
    // border: "1px solid #A4A4A4",
    borderRadius: "0.5rem",
  },
  cell: {
    color: "#183053",
    fontSize: "12px",
    padding: "16px 10px",
    textAlign: "left",
  },
  icon: {
    cursor: "pointer",
    marginRight: "16px",
    fontSize: "10px",
  },
  addNew: {
    display: "flex",
    justifyContent: "flex-end",
  },
  addNewLink: {
    width: "max-content",
    backgroundColor: "rgb(4, 61, 144)",
    // borderRadius: 8,
    padding: "5px 20px",
  },
  disabled: {
    pointerEvents: "none",
    opacity: 0.5,
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export default Styles;
